__turbopack_context__.v({
  "cardLift": "salary-insights-module__7Wd5iq__cardLift",
  "heroBlob": "salary-insights-module__7Wd5iq__heroBlob",
  "heroBlobLight": "salary-insights-module__7Wd5iq__heroBlobLight",
  "premiumRibbon": "salary-insights-module__7Wd5iq__premiumRibbon",
  "salaryResult": "salary-insights-module__7Wd5iq__salaryResult",
  "salaryResultPulse": "salary-insights-module__7Wd5iq__salaryResultPulse",
});
